import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import './../node_modules/bulma/css/bulma.css'
import VueProgressBar from 'vue-progressbar'
import VueMeta from 'vue-meta'
import { firestorePlugin } from 'vuefire'
import ElementUI from 'element-ui';
import { ElementTiptapPlugin } from 'element-tiptap';
// import ElementUI's styles
import 'element-ui/lib/theme-chalk/index.css';
// import this package's styles
import 'element-tiptap/lib/index.css';
import { fb } from './db'
// use ElementUI's plugin
Vue.use(ElementUI);
// use this package's plugin
Vue.use(ElementTiptapPlugin, { lang: "de" });
// Now you register `'el-tiptap'` component globally.

Vue.use(firestorePlugin)

let app = ''

const options = {
  color: '#bffaf3',
  autoFinish: false
}

Vue.use(VueProgressBar, options)

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

Vue.config.productionTip = false

fb.auth().onAuthStateChanged(() => {
  if(!app) {
    app = new Vue({
      router,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  }
})
